module.exports = __webpack_public_path__ + "img/194.a7795fb5.jpg";